module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms74e"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    ref: "hrms74eIndexSearchBoxTable",
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "unLoadBool": true,
      "receivedStore": _vm.callSearchIndex,
      "searchBoxAlias": "hrms74e",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.approveEvent,
      "addInlineEventBool": !_vm.coursend,
      "deleteInlineEventBool": true,
      "saveInlineEvent": _vm.callSave,
      "columnEvent": _vm.columnEvent,
      "saveInlineBtnDisp": false,
      "approveInlineBtnDisp": !_vm.coursend,
      "deleteInlineBtnDisp": false
    },
    on: {
      "setDataRowIndex": function($event) {
        _vm.dataRow = arguments[0]
      }
    },
    model: {
      value: (_vm.searchIndex),
      callback: function($$v) {
        _vm.searchIndex = $$v
      },
      expression: "searchIndex"
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "indexSelected": _vm.indexSelected,
      "nowLang": _vm.dash.nowLang,
      "toggle": _vm.toggle,
      "detail": _vm.detail,
      "tab2Table": _vm.columns[_vm.dash.nowLang].columnsTab2,
      "tab3Table": _vm.columns[_vm.dash.nowLang].columnsTab3
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bac08902!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms74e/component.vue
// module id = 3964
// module chunks = 1